module.exports = __webpack_public_path__ + "img/right_video3.4932a659.png";